module.exports = __webpack_public_path__ + "assets/img/img246.4f34571c.png";